import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { User } from 'src/app/models/user';
import { CommonService } from 'src/app/services/common.service';
import { OtpService } from 'src/app/services/otp.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-mobile-find-pw',
  templateUrl: './mobile-find-pw.component.html',
  styleUrls: ['./mobile-find-pw.component.css']
})
export class MobileFindPwComponent implements OnInit {

  constructor(
    private userService: UserService,
    private commonService: CommonService,
    private otpService: OtpService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    let user: User = this.commonService.getUserInfo()
    if(user) {
      this.router.navigate(['/'])
    }
    if(!this.commonService.getIsMobile()) {
      this.router.navigate(['/find/pw'])
    }
    this.userId = this.route.snapshot.params['userId']
    this.tel = this.route.snapshot.params['tel']
    this.otpCode = this.route.snapshot.params['otpCode']
    if(this.userId && this.tel && this.otpCode) {
      this.isOtpConfirm = true
    }
  }

  ngOnInit(): void {
  }
  isOtpSend: boolean = false
  userId: string
  tel: string
  otpCode: string
  findPwSend() {
    if(!this.userId) {
      return alert("아이디를 입력해 주세요")
    } else if (this.userId.length < 4) {
      return alert("아이디를 4자이상 입력해 주세요")
    }
    this.spinner.show()
    this.otpService.findPwSend(this.userId).subscribe(res => {
      this.spinner.hide()
      if(res.resultCode == '8888') {
        alert('존재하지 않는 아이디입니다.\n아이디를 확인해 주세요')
      } else {
        this.isOtpSend = true
        this.tel = res.data
        this.timer()
      }
    })
  }
  password: string
  passwordConfirm: string
  updatePassword() {
    if(!this.isPasswordCheck || !this.isConfirmPasswordCheck) {
      return alert('새 비밀번호를 확인해 주세요')
    }
    this.spinner.show()
    this.userService.updatePassword(this.userId, this.otpCode, this.password).subscribe(res => {
      this.spinner.hide()
      if(res.resultCode == '0000') {
        alert("정상적으로 변경되었습니다.")
        this.router.navigateByUrl('/login')
      } else {
        alert(res.message)
      }
    })
  }
  isPasswordCheck: boolean = false
  passwdCheckMsg: string
  checkPassword() {
    if(this.password) {
      let regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[~!@\#$%<>^&*+-])[A-Za-z\d~!@\#$%<>^&*+-]{8,}$/
      if(!regex.test(this.password)) {
        this.passwdCheckMsg = "비밀번호는 영문,숫자,특수문자(~!@\#$%<>^&*+-)조합으로 8자이상만 가능합니다"
      } else {
        this.isPasswordCheck = true
        this.passwdCheckMsg = null
      }
    }
    this.checkConfirmPassword()
  }
  confirmPasswdCheckMsg: string
  isConfirmPasswordCheck: boolean = false
  checkConfirmPassword() {
    if(this.password != this.passwordConfirm) {
      this.confirmPasswdCheckMsg = "비밀번호가 일치하지 않습니다"
      this.isConfirmPasswordCheck = false
    } else {
      this.confirmPasswdCheckMsg = null
      this.isConfirmPasswordCheck = true
    }
  }

  isOtpConfirmTry: boolean = false
  isOtpConfirm: boolean = false
  otpCheck() {
    if(!this.otpCode) {
      return alert("인증번호를 입력해 주세요")
    }
    this.isOtpConfirmTry = true
    this.otpService.findPwOtpCheck(this.userId, this.otpCode, this.intervalCheckTime).subscribe(res => {
      this.isOtpConfirm = res.data
      this.displayTime = ''
      clearInterval(this.timerInterval)
      if(this.isOtpConfirm) {
        this.toastr.success("인증이 완료되었습니다")
      } else {
        alert("인증번호가 일치하지 않습니다")
        this.isOtpConfirmTry = false
        this.isOtpSend = false
        this.otpCode = null
        this.tel = null
      }
    })
  }
  intervalCheckTime: number = 5
  displayTime: string
  timerInterval: any
  timer() {
    let minute = this.intervalCheckTime
    let seconds: number = minute * 60
    let textSec: any = "0"
    let statSec: number = 60
    const prefix = minute < 10 ? "0" : "";
    this.timerInterval = setInterval(() => {
      seconds--
      if (statSec != 0) {
        statSec--
      } else {
        statSec = 59
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      }
      this.displayTime =  prefix + (Math.floor(seconds / 60)) + ':' + textSec
      if (seconds == 0) {
        clearInterval(this.timerInterval)
        this.isOtpSend = false
      }
    }, 1000)
  }
}
